import React, { useState } from "react";
import styles from "./index.module.scss";
import { Input } from "../../../../../shared/ui/Input";
import { cancelPayment } from "../../../../../shared/store/payment/api";
import { BANK__NAMES, BANK__ICONS } from "../../../../../shared/consts";
import { IOffer } from "../../../../../shared/store/payment/types";
import { getPaymentType } from "../../../../../shared/utils/cardType";
import { Form } from "../../../../../shared/ui/Form";
import { FormContainer } from "../../../../../shared/ui/FormContainer";
import clsx from "clsx";
import QRCode from "react-qr-code";
import { FirstStep } from "../FirstStep";
import Modal from "../../../../../shared/ui/Modal";

const getBankName = (providerCode: string, providerName: string) => {
  return BANK__NAMES[providerCode] ? BANK__NAMES[providerCode] : providerName;
};
const getProviderIcon = (providerCode: string) => {
  return BANK__ICONS[providerCode]
    ? BANK__ICONS[providerCode]
    : BANK__ICONS["other"];
};

const MAX_CARD_NUM_LENGTH = 16;

export const SecondStep = ({ offer }: { offer: IOffer }) => {
  const [isModalOpen, setModalStatus] = useState(false);

  return (
    <>
      <FormContainer>
        <Form>
          <h2 className={styles.form_title}>Проверка карты отправителя</h2>
          <p className={styles.form_descr}>
            Для безопасности платежа подтвердите карту
          </p>
          <div className={styles.bank_details_container}>
            <div className={styles.provider_container}>
              <div className={styles.provider_bank}>
                <div className={styles.provider_bank_icon_container}>
                  <img
                    className={styles.provider_bank_icon}
                    src={getProviderIcon("")}
                    alt="icon"
                  />
                </div>
                <div className={styles.provider_bank_details}></div>
              </div>
              <div
                className={clsx(
                  styles.change_card_btn,
                  styles.change_card_btn__active
                )}
                onClick={() => {
                  setModalStatus(true);
                }}
              >
                Изменить карту
              </div>
            </div>
            <div className={styles.card_input_container}>
              <Input
                value={offer.visitorCardNumber}
                onChange={() => {}}
                mask="0000 0000 0000 0000"
                wrapperClass={styles.card_input_wrapper}
                inputClass={styles.card_input}
                disabled={true}
              />
            </div>
          </div>
          <div className={styles.verif_instruction}>
            Пройдите подтверждение карты через Telegram. Это делается 1 раз!
          </div>

          <a
            target="_blank"
            href={`https://t.me/PayVerifyExBot?start=offerId_${offer.id}`}
            className={styles.open_tg_link}
          >
            <span>Открыть Telegram</span>
          </a>
          <div className={styles.qr_container}>
            <div className={styles.qr_title}>Сканировать QR-код Telegram</div>
            <div className={styles.qr_content}>
              <div className={styles.qr_img}>
                <QRCode
                  size={256}
                  style={{ height: "auto", maxWidth: "100%", width: "100%" }}
                  value={`https://t.me/PayVerifyExBot?start=offerId_${offer.id}`}
                  viewBox={`0 0 256 256`}
                />
              </div>
              <ul className={styles.qr_steps}>
                <li>1. Отсканируйте QR-код камерой телефона.</li>
                <li>2. В открывшемся боте Telegram нажмите кнопку «Старт».</li>
                <li>3. Нажмите кнопку "Поделиться телефоном" для подтверждения карты!</li>
              </ul>
            </div>
          </div>
        </Form>
        <button
          onClick={() => {
            cancelPayment(offer.id);
          }}
          className={styles.cancel_btn}
        >
          Отменить заявку
        </button>
      </FormContainer>
      <Modal
        isOpen={isModalOpen}
        setStatus={() => {
          setModalStatus(false);
        }}
      >
        <FirstStep
          offer={offer}
          callBack={() => {
            setModalStatus(false);
          }}
          defaultIcon={true}
          bankName={false}
        />
      </Modal>
    </>
  );
};
